import {
	mdiAppsBox,
	mdiArchive,
	mdiBellOutline,
	mdiChatAlert,
	mdiGamepad,
	mdiGoogleCirclesCommunities,
	mdiHome,
	mdiKeyOutline,
	mdiPencilOutline,
	mdiLicense,
	mdiBullhorn,
	mdiMessage,
	mdiNewspaperVariantMultipleOutline,
	mdiPlusBoxOutline,
	mdiRobotOutline,
	mdiShieldAlertOutline,
	mdiSliderSettings,
	mdiTrophy,
	mdiWikipedia,
} from '@mdi/js'

// Array of sections

export default [
	{
		icon: mdiHome,
		title: 'Dashboard',
		to: 'community-dashboard',
	},
	{
		icon: mdiRobotOutline,
		title: 'menu.contentEngine',
		module: 'MGC,contents',
		children: [
			{
				title: 'menu.contentEngineQueue',
				to: 'community-content-engine',
			},
			{
				title: 'menu.contentEngineArticlesQueue',
				to: 'community-content-engine-articles-queue',
			},
			{
				title: 'menu.contentEngineFeeds',
				to: 'community-content-engine-feeds',
			},
			{
				title: 'menu.contentEngineSettings',
				to: 'community-content-engine-settings',
			},
		],
	},
	{
		title: 'Community',
		icon: mdiGoogleCirclesCommunities,
		module: 'MGC,community',
		children: [
			{
				title: 'menu.community.communities.communities',
				to: 'community-communities-list',
			},
			{
				title: 'menu.community.communities.creators',
				to: 'community-creators-list',
			},
			{
				title: 'menu.community.communities.features',
				to: 'community-features-list',
			},
			{
				title: 'menu.community.communities.ratings',
				to: 'community-ratings-list',
			},
			{
				title: 'menu.community.communities.comments',
				to: 'community-comments-list',
			},
		],
	},
	{
		title: 'Contents',
		icon: mdiArchive,
		module: 'MGC,contents',
		children: [
			{
				title: 'Pulses',
				children: [
					{
						title: 'menu.community.pulses.pulses',
						to: 'community-contents-pulses-list',
					},
					{
						title: 'menu.community.pulses.category',
						to: 'community-contents-pulses-category-list',
					},
					{
						title: 'menu.community.pulses.pending',
						to: 'community-contents-pulses-pending-list',
					},
					{
						title: 'menu.community.pulses.source',
						to: 'community-contents-pulses-source-list',
					},
					{
						title: 'menu.community.pulses.status',
						to: 'community-contents-pulses-status-list',
					},
				],
			},
			{
				title: 'menu.community.videos.videos',
				children: [
					{
						title: 'menu.community.videos.videos',
						to: 'community-contents-videos-list',
					},
					{
						title: 'menu.community.videos.category',
						to: 'community-contents-videos-category-list',
					},
					{
						title: 'menu.community.videos.sources',
						to: 'community-contents-videos-sources-list',
					},
				],
			},
			{
				title: 'menu.community.reviews.reviews',
				children: [
					{
						title: 'menu.community.reviews.list',
						to: 'community-contents-reviews-list',
					},
					{
						title: 'menu.community.reviews.create',
						to: 'community-contents-reviews-create',
					},
					{
						title: 'menu.community.reviews.aiCreate',
						to: 'community-contents-reviews-ai-create',
					},
					{
						title: 'menu.community.reviews.aiJobs',
						to: 'community-contents-reviews-ai-jobs',
					},
					{
						title: 'menu.community.reviews.distribution',
						to: 'community-contents-review-distributions-list',
					},
				],
			},
			{
				title: 'menu.community.quizzes',
				to: 'community-contents-quizzes-list',
			},
			{
				title: 'menu.community.pushNotifications',
				to: 'community-contents-push-notifications-list',
			},
			{
				title: 'menu.community.Schedulers',
				to: 'community-contents-schedulers-list',
			},
			{
				title: 'menu.community.translationQueue',
				to: 'community-contents-translation-queue-list',
			},
			{
				title: 'menu.community.contentRequests',
				to: 'community-content-requests-list',
			},
			{
				title: 'Showcase editorial coverage',
				to: 'community-showcase-coverage',
			},
			{
				title: 'menu.community.guestWriterInvites',
				to: 'community-guest-writer-invites-list',
			},
		],
	},
	{
		title: 'App',
		icon: mdiAppsBox,
		module: 'MGC,app',
		children: [
			{
				title: 'menu.accountBenefits',
				to: 'account-benefits-list',
			},
			{
				title: 'Themes',
				children: [
					{
						title: 'menu.themes.appThemes',
						to: 'app-themes-list',
					},
					{
						title: 'menu.themes.projectsVariables',
						to: 'projects-variables-list',
					},
				],
			},
		],
	},

	{
		title: 'Challenges',
		icon: mdiTrophy,
		module: 'MGC,community',
		children: [
			{
				title: 'All Challenges',
				to: 'community-challenges-list',
			},
			{
				title: 'New Challenge',
				to: 'community-challenges-create',
			},
		],
	},
	{
		title: 'Awards',
		icon: mdiLicense,
		module: 'MGC,awards',
		children: [
			{
				title: 'menu.votings',
				to: 'community-votings-list',
			},
		],
	},
	{
		title: 'menu.gameJams',
		icon: mdiGamepad,
		module: 'MGC,awards',
		children: [
			{
				title: 'menu.gameJamsOverview',
				to: 'community-game-jams-overview',
			},
			{
				title: 'menu.gameJamsAll',
				to: 'community-game-jams-all',
			},
			{
				title: 'menu.gameJamsReview',
				to: 'community-game-jams-review',
			},
			{
				title: 'menu.gameJamsReports',
				to: 'community-game-jam-reports',
			},
			{
				title: 'menu.gameJamSponsors',
				to: 'community-game-jam-sponsors-review',
			},
		],
	},

	{
		title: 'Wikigamer',
		icon: mdiWikipedia,
		module: 'MGC,wikigamer',
		children: [
			{
				title: 'menu.community.wikigamer.achievements',
				to: 'community-wikigamer-achievements-list',
			},
			{
				title: 'menu.community.wikigamer.characters.characters',
				children: [
					{
						title: 'menu.community.wikigamer.characters.characters',
						to: 'community-wikigamer-characters-list',
					},
					{
						title: 'menu.community.wikigamer.characters.genders',
						to: 'community-wikigamer-characters-genders-list',
					},
					{
						title: 'menu.community.wikigamer.characters.phrases',
						to: 'community-wikigamer-characters-phrases-list',
					},
					{
						title: 'menu.community.wikigamer.characters.species',
						to: 'community-wikigamer-characters-species-list',
					},
					{
						title: 'menu.community.wikigamer.characters.status',
						to: 'community-wikigamer-characters-status-list',
					},
					{
						title: 'menu.community.wikigamer.characters.statusWebsite',
						to: 'community-wikigamer-characters-status-website-list',
					},
				],
			},
			{
				title: 'menu.community.wikigamer.collections',
				to: 'community-wikigamer-collections-list',
			},
			{
				title: 'menu.companies.companies',
				children: [
					{
						title: 'menu.companies.companiesList',
						to: 'companies-list',
					},
					{
						title: 'menu.companies.companiesType',
						to: 'companies-type-list',
					},
				],
			},
			{
				title: 'menu.community.wikigamer.events.events',
				children: [
					{
						title: 'menu.community.wikigamer.events.eventsList',
						to: 'community-wikigamer-events-list',
					},
					{
						title: 'menu.community.wikigamer.events.eventsCategories',
						to: 'community-wikigamer-events-categories-list',
					},
				],
			},
			{
				title: 'menu.community.wikigamer.franchises',
				to: 'community-wikigamer-franchises-list',
			},
			{
				title: 'menu.community.wikigamer.games.games',
				children: [
					{
						title: 'menu.community.wikigamer.games.games',
						to: 'community-wikigamer-games-list',
					},
					{
						title: 'menu.community.wikigamer.games.gamesAchievements',
						to: 'community-wikigamer-games-achievements-list',
					},
					{
						title: 'menu.community.wikigamer.games.gamesEngines',
						to: 'community-wikigamer-games-engines-list',
					},
					{
						title: 'menu.community.wikigamer.games.gamesTypes',
						to: 'community-wikigamer-games-types-list',
					},
					{
						title: 'menu.community.wikigamer.games.gamesGenres',
						to: 'community-wikigamer-games-genres-list',
					},
					{
						title: 'menu.community.wikigamer.games.gamesModes',
						to: 'community-wikigamer-games-modes-list',
					},
					{
						title: 'menu.community.wikigamer.games.gamesPerspectives',
						to: 'community-wikigamer-games-perspectives-list',
					},
					{
						title: 'menu.community.wikigamer.games.gamesStatus',
						to: 'community-wikigamer-games-status-list',
					},
					{
						title: 'menu.community.wikigamer.games.gamesThemes',
						to: 'community-wikigamer-games-themes-list',
					},
					{
						title: 'menu.community.wikigamer.games.gamesWebsites',
						to: 'community-wikigamer-games-websites-list',
					},
					{
						title: 'menu.community.wikigamer.games.gamesPriceWatchlist',
						to: 'community-wikigamer-games-price-watchlist-list',
					},
				],
			},
			{
				title: 'menu.community.wikigamer.gamesRating.gamesRating',
				children: [
					{
						title: 'ESRB',
						to: 'community-wikigamer-games-rating-esrb-list',
					},
					{
						title: 'Pegi',
						to: 'community-wikigamer-games-rating-pegi-list',
					},
				],
			},
			{
				title: 'menu.community.wikigamer.platforms.platforms',
				children: [
					{
						title: 'menu.community.wikigamer.platforms.platforms',
						to: 'community-wikigamer-platforms-list',
					},
					{
						title: 'menu.community.wikigamer.platforms.generations',
						to: 'community-wikigamer-platforms-generations-list',
					},
					{
						title: 'menu.community.wikigamer.platforms.platformsFamily',
						to: 'community-wikigamer-platforms-family-list',
					},
					{
						title: 'menu.community.wikigamer.platforms.platformsType',
						to: 'community-wikigamer-platforms-types-list',
					},
				],
			},
			{
				title: 'menu.community.wikigamer.mediaTypes',
				to: 'community-wikigamer-media-types-list',
			},
			{
				title: 'menu.community.wikigamer.regions',
				to: 'community-wikigamer-regions-list',
			},
		],
	},
	{
		title: 'e-Sports',
		icon: mdiGamepad,
		module: 'MGC,esports',
		children: [
			{
				title: 'Teams',
				to: 'community-esports-teams-list',
			},
		],
	},
	{
		icon: mdiMessage,
		title: 'menu.messages',
		to: 'community-messages-list',
		module: 'MGC,messages',
	},
	{
		icon: mdiNewspaperVariantMultipleOutline,
		title: 'Newsletter',
		to: 'community-newsletter-list',
		module: 'MGC,newsletter',
	},
	{
		icon: mdiBellOutline,
		title: 'notifications.notifications',
		module: 'MGC,notifications',
		children: [
			{
				title: 'menu.notifications.list',
				to: 'community-notifications-list',
			},
			{
				title: 'menu.notifications.templates',
				to: 'network-notification-templates-list',
			},
		],
	},
	{
		title: 'menu.reports.title',
		icon: mdiChatAlert,
		module: 'MGC,reports',
		children: [
			{
				title: 'menu.reports.title',
				to: 'community-reports-list',
			},
			{
				title: 'categories',
				to: 'community-reports-categories-list',
			},
			{
				title: 'subCategories',
				to: 'community-reports-subcategories-list',
			},
		],
	},
	{
		icon: mdiKeyOutline,
		title: 'menu.community.gameClaims',
		to: 'community-game-claims-list',
		module: 'MGC,moderation',
	},
		{
			icon: mdiPencilOutline,
			title: 'menu.community.gameContributions',
			to: 'community-game-contributions-list',
			module: 'MGC,moderation',
		},
	{
		icon: mdiPlusBoxOutline,
		title: 'menu.community.gameCreationSuggestions',
		to: 'community-game-creation-suggestions-list',
		module: 'MGC,moderation',
	},
	{
		icon: mdiShieldAlertOutline,
		title: 'menu.community.moderation',
		to: 'community-moderation',
		module: 'MGC,moderation',
	},
	{
		icon: mdiSliderSettings,
		title: 'menu.community.feedConfig',
		to: 'community-feed-config',
		module: 'MGC,community',
	},
	{
		icon: mdiBullhorn,
		title: 'menu.community.feedPromotions',
		to: 'community-feed-promotions',
		module: 'MGC,community',
	},
]
